<div>
  <p>{{Text}}</p>
</div>
